import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ApiService, IBakery, TransferableGetApiService } from '@cakeiteasy/web-utils';
import { TransferState } from '@angular/core';

@Injectable()
export class BakeriesApiService extends TransferableGetApiService {

  constructor(@Inject('AppConfig') appConfig: any,
              @Inject(PLATFORM_ID) _platformId: any,
              transferState: TransferState,
              api: ApiService) {
    super(api, appConfig, _platformId, transferState);
  }

  public getBakeriesByCityPostNumber(cityName: string,
                                     countryCode: string,
                                     postNumber: string): Promise<any[]> {
    return this.api
      .get('api.bakery',
        'bakeries_by_city_post_number',
        { cityName }, {
          params: {
            countryCode,
            postNumber
          }
        })
      .toPromise();
  }

  getBakeryById(bakeryId: any): Promise<IBakery> {
    return this.getWithCaching('api.bakery',
      'bakery_by_id',
      { id: bakeryId })
      .toPromise();
  }

  getBakeryByRefName(refName: string, country?: string): Promise<IBakery> {
    return this.getWithCaching('api.bakery', 'bakery_by_name', { refName }, { params: { country } }).toPromise();
  }

  getCountryBakeries(countryCode: string) {
    return this.getWithCaching('api.bakery',
      'bakeries',
      {}, { params: { countryCode } })
      .toPromise();
  }

  getBakeriesByPlaceName(countryCode: string, query: string): Promise<IBakery[]> {
    return this.getWithCaching(
      'api.bakery',
      'bakeries_search',
      {}, { params: { countryCode, query, searchInPlaces: true } })
      .toPromise();
  }
}
